import { z } from 'zod';

import { exploreColumnSchema } from './explore-column';
import { exploreQuerySchema } from './explore-query';

export type ExploreStatisticsQuery = z.infer<typeof exploreStatisticsQuerySchema>;

export const exploreStatisticsQuerySchema = exploreQuerySchema.extend({
  columns: z.array(exploreColumnSchema),
});
